/*=========================================================================================
  File Name: moduleUserManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
==========================================================================================*/


import state from './moduleAdminManagementState.js'
import mutations from './moduleAdminManagementMutations.js'
import actions from './moduleAdminManagementActions.js'
import getters from './moduleAdminManagementGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

